import api from '@/utils/api'

export default {
  state: () => ({
    seoTemplatesList: null,
  }),
  mutations: {
    setSeoTemplatesList(state, payload) {
      state.seoTemplatesList = payload
    },
  },
  getters: {},
  actions: {
    async fetchSeoTemplatesList({ commit }) {
      const res = await api.http.get('admin/topic-city-templates')
      commit('setSeoTemplatesList', res?.data?.data)
      return res?.data?.data
    },

    async createSeoTemplate(_, formData) {
      await api.http.post('admin/topic-city-templates', formData)
    },

    async updateSeoTemplate(_, {formData, id}) {
      await api.http.put(`admin/topic-city-templates/${id}`, formData)
    },

    async deleteSeoTemplate(_, id) {
      await api.http.delete(`admin/topic-city-templates/${id}`)
    },

    async getSeoTemplateById(_, id) {
      const res = await api.http.get(`admin/topic-city-templates/${id}`)
      return res?.data?.data
    },
  },
  namespaced: true,
}


